import type { BackendObject, SSRObjectEntity, TransformedObject } from './types';

// ---

export const transformObject = (entry: BackendObject | SSRObjectEntity): TransformedObject => ({
  id: entry.id,
  type: entry.type,
  name: entry.name,
  icon: entry.icon,
});
